import { CreateOrUpdateFocusOkResponseBody, FocusDTO, FocusTabDTO } from "@/js/api/focus";
import { ResourceType, SelectedResource } from "./FocusResourcePicker/SelectedFocusResources";

export function transformSelectedResourcesToMatchAPIContract(selectedResources: SelectedResource[]): FocusTabDTO[] {
	return selectedResources.map((resource) => {
		return {
			id: resource.id,
			url: resource.resourceType === ResourceType.Url ? resource.resourceValue : undefined,
			signature: resource.resourceType === ResourceType.Signature ? resource.resourceValue : undefined,
			openTab: resource.openTab,
		};
	});
}

export function transformUpsertResonseToFocusItem(response: CreateOrUpdateFocusOkResponseBody): FocusDTO {
	return {
		id: response.id,
		name: response.name || "",
		focusTabs: response.focusTabs || [],
		tabsLocked: response.tabsLocked || false,
		lastUsed: response.lastUsed || 0,
		createdAt: response.createdAt || 0,
		active: response.active || false,
		studentIds: response.studentIds || [],
	};
}

type StudentWithIds = {
	stableIdV1?: string | null;
	qoriaUserId?: string | null;
};

export function mapStudentStableIdsToQoriaUserIds(
	students: StudentWithIds[] | null | undefined,
	stableIds: string[] | undefined
): string[] | undefined {
	if (!stableIds) {
		return undefined;
	}
	if (!students || students.length === 0) {
		return [];
	}

	const stableIdToQoriaIdMap = new Map<string, string>();
	for (const student of students) {
		if (student.stableIdV1 && student.qoriaUserId) {
			stableIdToQoriaIdMap.set(student.stableIdV1, student.qoriaUserId);
		}
	}

	return stableIds
		.map((stableId) => stableIdToQoriaIdMap.get(stableId))
		.filter((qoriaUserId): qoriaUserId is string => Boolean(qoriaUserId));
}
